import { Component, OnInit, OnDestroy } from '@angular/core';
import { take, Subscription } from "rxjs";
import { FormControl, Validators } from '@angular/forms';
import { UserSettingsService } from '../api/user-service/api/userSettings.service';
import { NewsletterUser } from '../api/user-service/model/newsletterUser';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
})
export class NewsletterComponent implements OnInit, OnDestroy {
  newsletterUsers: NewsletterUser[] | undefined;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
  ]);
  errorMessage: string = '';
  successMessage: string = '';
  private subscription = new Subscription();

  constructor(
    private userSettingsService: UserSettingsService,
  ) {
  }

  ngOnInit(): void {
    this.loadNewsletterUsers();

    // Clear status message when form changes
    this.subscription.add(
      this.emailFormControl.valueChanges.subscribe(() => {
        this.errorMessage = '';
        this.successMessage = '';
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  loadNewsletterUsers(): void {
    this.userSettingsService.getNewsletterEmails().pipe(take(1)).subscribe(users => {
      this.newsletterUsers = users;
    });
  }

  getEmailList(users: NewsletterUser[]): string {
    return users ? users.map(user => user.email).join('\n') : '';
  }

  removeFromNewsletter(): void {
    const emailToRemove = this.emailFormControl.value;

    // Find the user
    const userToRemove = this.newsletterUsers?.find(user => user.email === emailToRemove);
    if (!userToRemove) {
      this.errorMessage = 'Diese Mailadresse ist nicht für den Newsletter angemeldet.';
      this.successMessage = '';
      return;
    }

    this.userSettingsService.removeNewsletterSubscriber(userToRemove.userId).subscribe({
      next: () => {
        // Remove the user from the list
        this.newsletterUsers = this.newsletterUsers.filter(user => user.userId !== userToRemove.userId);
        this.emailFormControl.reset();
        this.successMessage = 'Mailadresse erfolgreich entfernt.';
        this.errorMessage = '';
      },
      error: (error) => {
        this.errorMessage = 'Fehler beim Entfernen der Mailadresse.';
        this.successMessage = '';
      }
    });
  }

  selectAllText(element): void {
    element.select();
  }
}
